import FabricationSequenceStore from "./FabricationSequence/FabricationSequenceStore";
import CastingMapStore from "./CastingMap/CastingMapStore";
import ProductionMonitorStore from "./ProductionMonitor/ProductionMonitor.Store";
import HoldManagementStore from "./HoldManagement/HoldManagement.Store";
import MoldEngineerAssignmentStore from "./MoldEngineerAssignment/MoldEngineerAssignment.Store";
import { ManholeViewStore } from "./manhole/stores/ManholeViewStore";
import TrailerLoadViewStore from "./trailer-load-builder/stores/TrailerLoadViewStore";
import ProductionScheduleUploadViewStore from "./ProductionScheduleUpload/ProductionScheduleUploadViewStore";
import MasterPieceListStore from "./MasterPieceList/MasterPieceListStore";

const productionStoreList = [
    { name: "fabricationSequenceStore", store: FabricationSequenceStore },
    { name: "castingMapStore", store: CastingMapStore },
    { name: "productionMonitorStore", store: ProductionMonitorStore },
    { name: "holdManagementStore", store: HoldManagementStore },
    { name: "moldEngineerAssignmentStore", store: MoldEngineerAssignmentStore },
    { name: "manholeViewStore", store: ManholeViewStore },
    { name: "trailerLoadViewStore", store: TrailerLoadViewStore },
    { name: "productionScheduleUploadViewStore", store: ProductionScheduleUploadViewStore },
    { name: "masterPieceListStore", store: MasterPieceListStore },
];

export default productionStoreList;
